import React, { useEffect, useMemo } from "react"

import type { DeepMap, FieldError, FieldValues } from "react-hook-form"

export const useScrollErroredInputIntoView = (
    inputName: string,
    containerRef: React.RefObject<HTMLDivElement | null>,
    reactHookFormErrors?: DeepMap<FieldValues, FieldError>,
    ignoreScrollIntoViewOnError?: boolean,
) => {
    // Identify if this input is first on the page with some error
    const isFirstInputWithError: boolean = useMemo(() => {
        if (!reactHookFormErrors) {
            return false
        }

        const firstInputWithError = Object.keys(reactHookFormErrors).reduce(
            (accumulator: string | null, currentValue: string) => {
                return accumulator && !!reactHookFormErrors?.[accumulator]
                    ? accumulator
                    : currentValue
            },
            null,
        )

        return firstInputWithError === inputName
    }, [reactHookFormErrors, inputName])

    // Scroll into view this input if it's first one on the page with error
    useEffect(() => {
        if (
            !isFirstInputWithError ||
            ignoreScrollIntoViewOnError ||
            !containerRef.current
        ) {
            return
        }

        try {
            containerRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            })
        } catch (e) {}
    }, [isFirstInputWithError])
}
